module.exports = __webpack_public_path__ + "static/media/cancel.1c42da3e.svg";